import { Text } from "@ui-kitten/components";
import { BaseCardListItem } from "components/BaseCard";
import { FeeCartItemDetails } from "features/types";
import React from "react";
import { View } from "react-native";
import { formatCurrency } from "utils/appUtils";

const getTotalFeesOrTaxesAmount = (
  feeItems: FeeCartItemDetails[],
  type: string
) => {
  const totalFeesOrTaxesAmount = feeItems.reduce((acc, feeItem) => {
    if (feeItem.feeType === type) {
      const { totalPrice } = feeItem;
      acc += Number(totalPrice);
    }
    return acc;
  }, 0);
  return formatCurrency(totalFeesOrTaxesAmount);
};
const FeeDetails = ({ feeItems }: { feeItems: FeeCartItemDetails[] }) => {
  const totalFeesAmount = getTotalFeesOrTaxesAmount(feeItems, "FEE");
  const totalTaxesAmount = getTotalFeesOrTaxesAmount(feeItems, "TAX");

  return (
    <View>
      <BaseCardListItem
        title="Digital Ticketing & Services Fee:"
        description="Covers tech, access, and secure ticket delivery."
        accessoryRight={<Text category="s1">{totalFeesAmount}</Text>}
        showArrow={false}
      />
      <BaseCardListItem
        title="Sales Tax:"
        description="Calculated based on your location."
        accessoryRight={<Text category="s1">{totalTaxesAmount}</Text>}
        showArrow={false}
      />
    </View>
  );
};

export default FeeDetails;
